export const GROUPE_COLORS = {
  'ACHEVEMENT & TIRAGE': '#90EE90',
  'DOSSIER DE CLASSEMENT 1ère / 2ème catégorie': '#87CEEB',
  'MISE A JOUR 1ère / 2ème catégorie': '#87CEEB',
  'DOSSIER DE CLASSEMENT 3ème catégorie': '#B0C4DE',
  'ETABLISSEMENT RECEVANT DU PUBLIC': '#DDA0DD',
  'ETUDE DE SECURITE INCENDIE': '#F0E68C',
  'Etude d\'environnement': '#98FB98',
  'DOSSIER D\'APPEL D\'OFFRE / C.C / BORDOREAU': '#FFB6C1',
  'PLAN D\'EVACUATION': '#FFA07A',
  'PLANS': '#20B2AA',
  'POI / REGISTRE DE SECURITE / NH': '#DEB887',
  'DIAGNOSTIQUE SECURITE ET PLAN D\'ACTION': '#F4A460',
  'Autres Missions': '#ddb97bff',
  'Tâche non planifiée': '#E8E8E8',
};

// Ordre prédéfini des catégories - seules les catégories existantes seront affichées
export const GROUPE_ORDER = [
  'ACHEVEMENT & TIRAGE',
  'DOSSIER DE CLASSEMENT 1ère / 2ème catégorie',
  'MISE A JOURS 1ère / 2ème catégorie',
  'DOSSIER DE CLASSEMENT 3ème catégorie',
  'ETABLISSEMENT RECEVANT DU PUBLIC',
  'ETUDE DE SECURITE INCENDIE',
  'Etude d\'environnement',
  'DOSSIER D\'APPEL D\'OFFRE / C.C / BORDOREAU',
  'PLAN D\'EVACUATION',
  'PLANS',
  'POI / REGISTRE DE SECURITE / NH',
  'DIAGNOSTIQUE SECURITE ET PLAN D\'ACTION',
  'Autres Missions',
  'Tâche non planifiée',
];
